// 该文件由 OneAPI 自动生成，请勿手动修改！
import { API_v2 } from '@/services/config';
import { request } from '@umijs/max';

export function getRoutesList(
  params: {
    platform_id?: number;
    platform_entity_id?: number;
    keyword?: string;
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
): Promise<Routes.RoutesMenuItem[]> {
  return request<Routes.RoutesMenuItem[]>(API_v2.getRoutesList, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取角色列表( table )
 * @param params
 * @param options
 */
export async function getRoleList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    platform_id?: number | string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getRoleList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 获取角色详情
 * @param params
 * @param options
 */
export async function getRoleDetail(
  params: {
    role_id?: string | number | any;
    role_ids?: string[] | number[] | any[];
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getRoleDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 获取菜单列表
 * @param params
 * @param options
 */
export async function getMenuList(
  params: {
    platform_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMenuList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 获取已选中的菜单列表
 * @param params
 * @param options
 */
export async function getRoleMenuList(
  params: {
    role_id?: string;
    platform_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getRoleMenuList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 修改角色菜单
 * @param data
 * @param options
 */
export async function editRole(
  data: {
    role_id?: string;
    menu?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editRole, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改角色菜单
 * @param data
 * @param options
 */
export async function addRole(
  data: {
    role_id?: string;
    menu?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addRole, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除角色
 * @param params
 * @param options
 */
export async function delRole(
  params: {
    role_id: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delRole, {
    method: 'POST',
    params,
    ...(options || {}),
  });
}
